import Vue from "vue";
import VueRouter from "vue-router";
import { Routes } from "./routes";
import store from "@/store";
import { camelCase, startCase } from "lodash";
import { auth } from "@/configs/firebase";
import Logger from "@/configs/logger";

import PublicLayout from "../layouts/Public.vue";
import AppLayout from "../layouts/App.vue";

import Home from "../views/Home.vue";
import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";
import Commissions from "../views/Commissions.vue";
import CallHistory from "../views/CallHistory.vue";
import OnHold from "../views/OnHold.vue";
import Agents from "../views/Agents.vue";
import Verification from "../views/Verification.vue";
import PostDates from "../views/PostDates.vue";
import DIDs from "../views/DIDs.vue";
import KibanaDashboard from "../views/KibanaDashboard.vue";
import ViewLead from "../views/ViewLead.vue";
import LeadLookup from "../views/LeadLookup.vue";
import TwilioEvents from "../views/TwilioEvents.vue";
import Leads from "../views/Leads.vue";
import LeadSources from "../views/LeadSources.vue";
import DoctorNominations from "../views/Nominations.vue";
import Settings from "../views/Settings.vue";
import Products from "../views/Products.vue";
import Dispositions from "../views/Dispositions.vue";
import MessageTemplates from "../views/MessageTemplates.vue";
import SessionExpired from "../views/SessionExpired.vue";
import Blacklist from "../views/Blacklist.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: PublicLayout,
    children: [
      {
        path: "",
        name: Routes.Home,
        component: Home,
        meta: {
          isPublic: true
        }
      },
      {
        path: "session-expired",
        name: Routes.SessionExpired,
        component: SessionExpired,
        meta: {
          isPublic: true
        }
      },
      {
        path: "login",
        name: Routes.Login,
        component: Login,
        meta: {
          isPublic: true
        }
      }
    ]
  },
  {
    path: "/dashboard",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.DashBoard,
        component: Dashboard
      }
    ]
  },
  {
    path: "/call-history",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.CallHistory,
        component: CallHistory
      }
    ]
  },
  {
    path: "/on-hold",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.OnHold,
        component: OnHold
      }
    ]
  },
  {
    path: "/agents",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Agents,
        component: Agents
      }
    ]
  },
  {
    path: "/verification",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Verification,
        component: Verification
      }
    ]
  },
  {
    path: "/post-dates",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.PostDates,
        component: PostDates
      }
    ]
  },
  {
    path: "/dids",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.DIDs,
        component: DIDs
      }
    ]
  },
  {
    path: "/kibana-dashboard",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Kibana,
        component: KibanaDashboard
      }
    ]
  },
  {
    path: "/lead",
    component: AppLayout,
    children: [
      {
        path: "view/:id",
        name: Routes.ViewLead,
        component: ViewLead
      },
      {
        path: "lookup",
        name: Routes.LookupLead,
        component: LeadLookup
      }
    ]
  },
  {
    path: "/commissions",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Commissions,
        component: Commissions
      }
    ]
  },
  {
    path: "/twilio-events",
    component: AppLayout,
    children: [
      {
        path: ":taskSID",
        name: Routes.TwiloEvents,
        component: TwilioEvents
      }
    ]
  },
  {
    path: "/leads",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Leads,
        component: Leads
      }
    ]
  },
  {
    path: "/lead-sources",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.LeadSources,
        component: LeadSources
      }
    ]
  },
  {
    path: "/nominations",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.DoctorNominations,
        component: DoctorNominations
      }
    ]
  },
  {
    path: "/settings",
    component: AppLayout,
    children: [
      {
        path: "",
        name: Routes.Settings,
        component: Settings
      },
      {
        path: "products",
        name: Routes.Products,
        component: Products
      },
      {
        path: "dispositions",
        name: Routes.Dispositions,
        component: Dispositions
      },
      {
        path: "message-templates",
        name: Routes.MessageTemplates,
        component: MessageTemplates
      },
      {
        path: "blacklist",
        name: Routes.Blacklist,
        component: Blacklist
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

/**
 * router.beforeEach((to, from, next) => {
  window.console.log("to", to);
  //@ts-ignore
  const roles = store.state.user.roles || [];
  const featureAccess: any = store.state.access.featureAccess;
  const pathNamePascalCase = startCase(camelCase(to.name)).replace(/ /g, "");
  window.console.log("access:", featureAccess);
  if (to.meta.isPublic) {
    next();
  } else {
    try {
      if (auth().currentUser) {
        if (pathNamePascalCase === "Dashboard") {
          next();
          return;
        }
        if (roles.includes("admin")) {
          next();
          return;
        }
        if (featureAccess[pathNamePascalCase]) {
          next();
          return;
        } else {
          throw new Error("Insufficient permission to view page");
        }
      } else {
        throw new Error("Insufficient permission to view page");
      }
    } catch (error) {
      Logger("error", error);
      next("/");
    }
  }
});
 */

export default router;
